<template>
  <div>
    <el-card shadow="never">
      <div slot="header" class="clearfix">
        <span>版署数据上报错误统计</span>
      </div>
      <el-form :inline="true" :model="form" ref="form" size="mini">
        <el-form-item label="日期">
          <el-date-picker v-model="dateTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            @change="handleRuleTime">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="query">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="handleExcel">EXCEL</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-table :data="list" size="mini">
      <el-table-column prop="applyNo" label="应用编号"></el-table-column>
      <el-table-column prop="applyName" label="应用名称" width="200"></el-table-column>
      <el-table-column prop="result" label="错误信息"></el-table-column>
      <el-table-column prop="createDate" label="错误时间" width="300"></el-table-column>
    </el-table>

    <el-pagination style="float:right;margin:10px" @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="page.pageSize"
      layout="total, prev, pager, next"
      :total="page.totalSize">
    </el-pagination>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  data () {
    return {
      dateTime:[],
      list: [],
      page:{},
      form:{
        start:'',
        end:'',
        pageNum:1
      }
    }
  },
  created(){

  },
  methods: {
    download (data,name) {
        if (!data) {
            return
        }
        let url = window.URL.createObjectURL(new Blob([data]))
        let link = document.createElement('a')
        link.style.display = 'none'
        link.target = "_blank";
        link.href = url
        link.setAttribute('download', name + '.xlsx')
        document.body.appendChild(link)
        link.click()
    },
    handleExcel(d){
        let name = "版署数据上报错误统计";
        let info = this.$store.state.userInfo;
        _this.formSearch.merchno = info.userbh;
        let url = "coupon-system/merch/get_loginout_err/excel";
        this.$download(url,this.formSearch).then((res) => {
          this.download(res,name)
        }).catch(err => {
          this.$message.error("下载失败");
      })
    },
    handleRuleTime(){
      if (this.dateTime != null) {
				this.form.start = this.dateTime[0];
				this.form.end = this.dateTime[1];
			}else{
        this.form.start = '';
				this.form.end = '';
      }
    },
    handleCurrentChange(val) {
      this.form.pageNum = val;
      this.query();
    },
    query(){
      let _this = this;
      let info = this.$store.state.userInfo;
      _this.form.merchno = info.userbh;
      this.$ajax({
        url:"coupon-system/merch/get_loginout_err",
        data:_this.form,
        async:false,
        methods:"POST",
        success:function(response){
          if (response.code==0) {
            _this.list = response.data.content || [];
            _this.page = response.data;
          }
        },
        error:function(){
          _this.$message.error("请求失败");
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/merch/loginout_err_mer.vue